var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "textarea-con 222", style: { maxWidth: _vm.textAreaWidth } },
    [
      _c("el-input", {
        attrs: {
          type: "textarea",
          resize: "none",
          autosize: { minRows: _vm.rowsNumber, maxRows: 10 },
          placeholder: "您可以在这里向我提问 ...",
          disabled: _vm.loading,
        },
        nativeOn: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.handleSendQuestion(_vm.searchValue)
          },
        },
        model: {
          value: _vm.searchValue,
          callback: function ($$v) {
            _vm.searchValue = $$v
          },
          expression: "searchValue",
        },
      }),
      _c(
        "div",
        { staticClass: "btn-con" },
        [
          _c("div", { staticClass: "flex items-center" }, [
            _c(
              "div",
              {
                staticClass: "flex items-center",
                staticStyle: { "margin-top": "5px" },
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "13px",
                      color: "#777",
                      margin: "-1px 5px 0 0",
                    },
                  },
                  [_vm._v("是否联网")]
                ),
                _c("el-switch", {
                  attrs: { "active-color": "#464BFE" },
                  on: { change: _vm.handleChangeSwitch },
                  model: {
                    value: _vm.isInternet,
                    callback: function ($$v) {
                      _vm.isInternet = $$v
                    },
                    expression: "isInternet",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-tooltip",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading,
                  expression: "!loading",
                },
              ],
              attrs: {
                effect: "dark",
                content: "请输入你的问题",
                placement: "top",
                transition: "",
                disabled: !!_vm.searchValue,
                "popper-class": "hover-popper",
              },
            },
            [
              _c("div", [
                !/^\s*$/.test(_vm.searchValue)
                  ? _c("img", {
                      attrs: {
                        src: require("@/assets/images/question/pushText.png"),
                        height: "30",
                        width: "30",
                        alt: "send",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSendQuestion(_vm.searchValue)
                        },
                      },
                    })
                  : _c("img", {
                      attrs: {
                        src: require("@/assets/images/question/not_text.png"),
                        height: "30",
                        width: "30",
                        alt: "send",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSendQuestion(_vm.searchValue)
                        },
                      },
                    }),
              ]),
            ]
          ),
          _c(
            "el-tooltip",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                effect: "dark",
                content: "终止回答",
                placement: "bottom",
                transition: "",
                "popper-class": "hover-popper",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "termination-btn",
                  on: { click: _vm.handleAbortRequest },
                },
                [_c("p")]
              ),
            ]
          ),
        ],
        1
      ),
      _vm.$route.name === "technicalQAHistory" ||
      _vm.$route.name === "technicalQAHistoryGuoJiao"
        ? _c("div", { staticClass: "ai-tips" }, [
            _c("span", [_vm._v("注：该内容由AI大模型生成，请谨慎甄别")]),
          ])
        : _vm._e(),
      _c("paymentDialog", {
        ref: "scholarSearchPayment",
        attrs: { payType: "专家查询" },
      }),
      _c("paymentDialog", {
        ref: "technicalQAPayment",
        attrs: { payType: "技术问答" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }